import type { GetStaticProps } from 'next'
import ImageBanner from '@components/ImageBanner'
import type { pageTitle, pageContent } from '@lib/types'
import { CarouselBasic } from '@components/Carousels'
import { getPageTitleContentFromDB, getPageContentFromDB } from '@lib/pagequerys'

import { Container, Heading, LinkComponent, Section, Text } from '@components/SectionComponents'

// Gets static props from DB
export const getStaticProps: GetStaticProps = async () => {

  const pageIdDB: number = 22;

  // query DB for page title data
  const pageTitle: pageTitle = await getPageTitleContentFromDB(pageIdDB);

  // Array of pageContent - query DB for pageContent data
  const pageContent: pageContent[] = await getPageContentFromDB(pageIdDB);

  return {
    props: {
      pageTitle,
      pageContent
    }
  }
}

// Home Page takes a pageTitle, and pageContent array
export default function Page({ pageTitle, pageContent }: {
  pageTitle: pageTitle,
  pageContent: pageContent[],
}) {

  return <>
    <ImageBanner title={pageTitle} />

    {/* Section 0 */}
    <Section colour='brown'>
      <Container longer='bottom'>
        <Heading h1={true} content={{
          title: pageContent[0].title,
          subtitle: pageContent[0].subtitle
        }} />
        <Text content={pageContent[0].text} />
        <LinkComponent link1={pageContent[0].link1} />
      </Container>
      <CarouselBasic images={pageContent[0].carouselImages} overlap='bottom' />
    </Section>

    {/* Section 1 */}
    <Section colour='cream'>
      <Container longer='top'>
        <Heading content={{
          title: pageContent[1].title,
          subtitle: pageContent[1].subtitle
        }} />
        <Text content={pageContent[1].text} />
        <LinkComponent link1={pageContent[1].link1} />
      </Container>
    </Section>

    {/* Section 2 */}
    <Section colour='white'>
      <Container>
        <Heading content={{
          title: pageContent[2].title,
          subtitle: pageContent[2].subtitle
        }} />
        <Text content={pageContent[2].text} />
        <LinkComponent link1={pageContent[2].link1} />
      </Container>
    </Section>

  </>;
}

//Meta Data
Page.title = "Sunshine Coast";
Page.description = "Make the most of your trip and find exciting places to visit on the Sunshine Coast and its surrounding area!";